
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thank-you-contacting-baywood-greens",
      function () {
        return require("private-next-pages/thank-you-contacting-baywood-greens.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/thank-you-contacting-baywood-greens"])
      });
    }
  